let _ = t => t,
    _t,
    _t2;

import styled from 'styled-components'; // @ts-expect-error not migrated to TS

import breakpoint from '../utils/responsiveBreakpoints';
import { GYPSUM, OLAF } from 'HubStyleTokens/colors';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
export const HeaderSection = styled.div.withConfig({
  displayName: "FeatureStyledComponents__HeaderSection",
  componentId: "sc-1rf0sgk-0"
})(["box-shadow:0 2px 4px 0 rgba(37,37,37,0.2);z-index:100;"]);
export const ModalHeader = styled.div.withConfig({
  displayName: "FeatureStyledComponents__ModalHeader",
  componentId: "sc-1rf0sgk-1"
})(["text-align:center;background-color:", ";padding:20px 0;& > h3{margin:0;}img{height:20px;}"], GYPSUM);
export const StyledTier = styled.div.withConfig({
  displayName: "FeatureStyledComponents__StyledTier",
  componentId: "sc-1rf0sgk-2"
})(["display:none;width:90%;margin:0 auto;padding:2rem 0;text-align:center;button{font-size:0.75rem;cursor:pointer;padding:calc(1rem + 1px) 2rem;background:#fff;border:1px solid #7fd1de;flex-basis:25%;margin-right:-1px;text-align:center;transition:background-color 0.3s;&:hover{background-color:#e5f5f8;}&.active{font-weight:500;padding:1rem 2rem;border-width:2px;border-color:#00a4bd;background-color:#e5f5f8;}}button:first-child{border-radius:3px 0 0 3px;}button:last-child{border-radius:0 3px 3px 0;margin-right:0;}ul{display:none;list-style:none;padding:0;width:60%;margin:0 auto;text-align:left;li{font-size:16px;cursor:pointer;color:#0091ae;}}#tierToggle{position:absolute;top:-9999px;left:-9999px;}input[type='checkbox']:checked ~ label ~ ul{display:block;}", ";", ";"], breakpoint.tabletPortrait(_t || (_t = _`
  display: flex;
`)), breakpoint.phone(_t2 || (_t2 = _`
  display: block;
  padding: 1rem 0;
`)));
export const TierSelected = styled.label.withConfig({
  displayName: "FeatureStyledComponents__TierSelected",
  componentId: "sc-1rf0sgk-3"
})(["color:#0091ae;font-size:18px;font-weight:600;margin-right:3px;cursor:pointer;"]);
export const Table = styled.table.withConfig({
  displayName: "FeatureStyledComponents__Table",
  componentId: "sc-1rf0sgk-4"
})(["border-spacing:0;width:100%;margin-bottom:0;"]);
export const TopHeaderCell = styled.th.withConfig({
  displayName: "FeatureStyledComponents__TopHeaderCell",
  componentId: "sc-1rf0sgk-5"
})(["padding:20px;background-color:", ";height:50px;text-align:center;width:18.75%;min-width:175px;& > h6{margin:0;}:first-child{padding:0;width:2%;min-width:30px;}:nth-child(2){padding-left:0;width:25%;text-align:left;}"], OLAF);
export const CenteredSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "FeatureStyledComponents__CenteredSpinner",
  componentId: "sc-1rf0sgk-6"
})(["justify-content:center;margin-top:12px;margin-bottom:12px;"]);